<template>
  <div>
      <Toast />
      <ConfirmDialog></ConfirmDialog>
      <Message v-if="!domain.is_enabled" severity="warn">Domain is disabled</Message>
      <Breadcrumb :home="bc_home" :model="bc_items" />
      <DomainNavBar :domain="domain"/>

      <Panel header="Settings" class="p-mt-3">
          <form autocomplete="off">
            <div class="p-fluid">
              <div class="p-field-checkbox">
                  <Checkbox id="active" :binary="true" v-model="domain.is_enabled"></Checkbox>
                  <label for="active">Active</label>
              </div>
              <h5>Services</h5>
              <div v-for="service of services" :key="service.key" class="p-field-checkbox">
                  <Checkbox :id="service.key" name="service" :value="service.key" v-model="domain.services"/>
                  <label :for="service.key">{{service.name}}</label>
              </div>
            </div>
            <Button label="Remove" class="p-button-text p-button-danger" @click="confirmDelete"></Button>
            <Button label="Update" icon="pi pi-check-square" :loading="loading" @click="saveDomain"></Button>
          </form>
      </Panel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DomainNavBar from '../components/DomainNavBar.vue'

export default {
  name: 'DomainSettings',
  components: {
    DomainNavBar,
  },
  data () {
    return {
      errors: {},
      loading: false,
      domain: {id: null, name: "", services: [], attributes: [], is_enabled: true},
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
      ],
      selectedServices: [],
      services: [
        {"key": "dns", "name": "DNS"},
        {"key": "mail", "name": "Mail"},
      ]
    }
  },
  created: function () {
    //this.GetDomain(this.$route.params.domain_id)
  },
  computed: {
    ...mapGetters({ Domains: 'StateDomains', GetDomain: 'GetDomain' }),
  },
  created: function () {
    //console.log(this.Domains)
    this.GetDomain(this.$route.params.domain_id)
      .then(response => {
        this.domain = response
        this.bc_items = [
          {label: this.domain.name, to: '/domains/'+this.$route.params.domain_id},
        ]
        this.domain.services = []
        const services = this.getServices(this.domain.attributes)
        if (services) {
          if (services.mail && services.mail.enabled == true) {
            this.domain.services.push("mail")
          }
          if (services.dns && services.dns.enabled == true) {
            this.domain.services.push("dns")
          }
        }

        this.bc_items.push({label: "Settings"})
      })
  },
  methods: {
    ...mapActions(['UpdateDomain', 'DeleteDomain']),
    getServices(attr) {
      if (attr) { 
        const result = attr.find( x => x.key === "services");
        if (result) {
          return result["value"]
        }
      }
    },
    saveDomain () {
      this.loading = true
      this.errors = {}
      
      //this.account.domain_id = this.$route.params.domain_id

      this.UpdateDomain(this.domain)
        .then(response => {
          ///this.domain = {id: '', name: '', services: [], is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Domain updated', detail:response.data.name, life: 3000});
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
        .finally(() => this.loading = false)
    },
    confirmDelete() {
        this.$confirm.require({
            message: 'Are you sure you want to remove this domain?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger',
            accept: () => {
              this.DeleteDomain(this.domain)
              .then(response => {
                this.$toast.add({severity:'info', summary:'Confirmed', detail:'Domain removed', life: 3000});
                this.$router.push('/domains')
              })  
            },
        });
    },
    //...mapActions(['CreateDomain', 'GetDomains']),
    //async submit () {
    //  await this.CreateDomain(this.form)
    //},
    //async selectDomain(id) {
    //  console.log("selectDomain", id)
    //  this.$router.push('/domains/' + id + '/mail/accounts')
    //  
    //}
  }
}
</script>

<style scoped>

</style>
